import React from "react";

import { ENABLE_LCA_SUPPLIER_UI_REDESIGN } from "../config/constants";
import SupplierListNew from "../screens/lcaSupplier/supplierList/SupplierListNew";
import SupplierList from "../screens/supplier/supplierList/SupplierList";
import { adminAccess, userAccess, supplierAccess } from "./useRoleAccess";

const SupplierGrid = ENABLE_LCA_SUPPLIER_UI_REDESIGN ? <SupplierListNew /> : <SupplierList />;

export const SupplierRoutes = [
  {
    path: "/supplier",
    route: SupplierGrid,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess, ...supplierAccess],
  },
];
